import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import PegRedemptionCard from './PegRedemptionCard';
import { getSessionStorageKey } from '../../../util/sessionStorage';

var PegRedemptionCardListing = function PegRedemptionCardListing(props) {
  var _NoPegCopy$value;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      balancePoints = _useState2[0],
      setBalancePoints = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      cards = _useState4[0],
      setCards = _useState4[1];

  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      selectedValues = props.selectedValues,
      setSelectedValues = props.setSelectedValues,
      availablePegRewards = props.availablePegRewards;
  var Header = model.Header,
      NoPegCopy = model.NoPegCopy,
      InformationCopy = model.InformationCopy,
      PegCardListing = model.PegCardListing,
      DisclaimerCopy = model.DisclaimerCopy;
  useEffect(function () {
    var rewardsStorage = getSessionStorageKey("rewards");

    if (rewardsStorage === null || rewardsStorage === void 0 ? void 0 : rewardsStorage.userPegs) {
      setBalancePoints(parseInt((rewardsStorage === null || rewardsStorage === void 0 ? void 0 : rewardsStorage.userPegs) || 0));
    } // Storybook only


    if (props.storybookPegsBalance) {
      setBalancePoints(parseInt(props.storybookPegsBalance || 0));
    }
  }, []);
  useEffect(function () {
    var sortedCards = PegCardListing.sort(function (a, b) {
      return parseInt(b.fields.PegNumber.value) - parseInt(a.fields.PegNumber.value);
    });
    var filteredCards = sortedCards.filter(function (pegCard) {
      return parseInt(balancePoints) >= parseInt(pegCard.fields.PegNumber.value);
    });
    setCards(filteredCards);
  }, [balancePoints]);
  return /*#__PURE__*/React.createElement("div", {
    className: 'peg-redemption-card-listing'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'peg-redemption-card-listing__header'
  }, Header === null || Header === void 0 ? void 0 : Header.value), cards.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: 'peg-redemption-card-listing__copy'
  }, InformationCopy === null || InformationCopy === void 0 ? void 0 : InformationCopy.value), /*#__PURE__*/React.createElement("div", {
    className: 'peg-redemption-card-listing__container'
  }, cards.map(function (pegCard, index) {
    return /*#__PURE__*/React.createElement(PegRedemptionCard, {
      key: "bonus-reward-".concat(index),
      id: "bonus-reward-".concat(index),
      model: pegCard.fields,
      available: parseInt(pegCard.fields.PegNumber.value) <= parseInt(availablePegRewards),
      selectedValues: selectedValues,
      setSelectedValues: setSelectedValues
    });
  })), /*#__PURE__*/React.createElement("span", {
    className: 'peg-redemption-card-listing__disclaimer-copy'
  }, DisclaimerCopy === null || DisclaimerCopy === void 0 ? void 0 : DisclaimerCopy.value)) : balancePoints < 75 && /*#__PURE__*/React.createElement("span", {
    className: 'peg-redemption-card-listing__no-peg-copy'
  }, NoPegCopy === null || NoPegCopy === void 0 ? void 0 : (_NoPegCopy$value = NoPegCopy.value) === null || _NoPegCopy$value === void 0 ? void 0 : _NoPegCopy$value.replace('<current peg total>', balancePoints)));
};

export default PegRedemptionCardListing;